export default "__VITE_ASSET__60487327__"